import { Box, Stack, Typography } from "@mui/material";
import { useIsMobile } from "Hooks/useIsMobile";

const MIN_WIDTH_MOBILE = 300; // on mobile we have to go lower because the preview has some spacing around itself, that then breaks the layout on very small screens
const MIN_WIDTH_DESKTOP = 350;
const MAX_WIDTH = 740;

type Props = {
  title: string;
  children: React.ReactNode;
  containerRef: React.Ref<HTMLDivElement>;
  width: number;
};

export const PreviewCard = ({
  title,
  children,
  containerRef,
  width,
}: Props) => {
  const isMobile = useIsMobile();
  const minWidth = isMobile ? MIN_WIDTH_MOBILE : MIN_WIDTH_DESKTOP;

  return (
    <Stack gap={1} alignItems="center">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        alignSelf="stretch"
      >
        <Typography variant="body1">{title}</Typography>
        <Typography variant="caption" color="text.secondary">
          {Math.round(width)}px
        </Typography>
      </Stack>
      <Box
        ref={containerRef}
        sx={{
          resize: "horizontal",
          overflow: "hidden",
          minWidth,
          maxWidth: MAX_WIDTH,
          width: minWidth,
          border: 1,
          borderColor: "divider",
          borderRadius: 2,
          backgroundColor: "#FAFAFA",
        }}
      >
        <Box sx={{ pointerEvents: "none", userSelect: "none", px: 2, py: 3 }}>
          {children}
        </Box>
      </Box>
    </Stack>
  );
};
